import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import SimpleAccordionContent from "../common/SimpleAccordionContent";
import { getIndividualReportPart } from "./ReportElementHelper";
import HouseIcon from "../../assets/images/house_36x36.png";

class PropertyDataRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      persons: [],
      activeIndex: 0,
    };
  }
  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    let rows = [];
    const { addressNode } = this.props;
    if (addressNode !== undefined) {
      const record = _.get(addressNode, "propertyData[0]");
      if (record !== null && Object.keys(record).length > 0) {
        rows = getIndividualReportPart(record, this.props);
      }
      // getAllRows(record, rows, this.props, undefined, 0);
    }
    if (rows.length === 0) return null;
    const headerRows = [];
    const title = `${_.get(addressNode, "fullAddress[0]._", "")}, ${_.get(
      addressNode,
      "city[0]._",
      ""
    )}, ${_.get(addressNode, "state[0]._", "")} ${_.get(
      addressNode,
      "zip[0]._",
      ""
    )}`;
    headerRows.push(
      <Table.Row>
        <Table.Cell>
          <span className="float-left">
            <img
              id={`caseCheck_${this.props.compType}`}
              src={HouseIcon}
              alt="House"
            />
          </span>
          <span className="float-right">Site Address:</span>
        </Table.Cell>
        <Table.Cell>
          <span className="red-text medium-font text-bold">{title}</span>
        </Table.Cell>
      </Table.Row>
    );
    headerRows.push(
      <Table.Row>
        <Table.Cell colSpan={2} className="report-sub-sub-section-header">
          Property Data
        </Table.Cell>
      </Table.Row>
    );
    rows = _.concat(headerRows, rows);
    return <SimpleAccordionContent {...this.props} name={title} rows={rows} />;
  }
}
export default PropertyDataRecord;



// WEBPACK FOOTER //
// ./src/components/reports/PropertyDataRecord.js